export const IconActionsPlus: {
  name: 'icon_actions_plus-bba49d3aed8b'
} = {
  name: 'icon_actions_plus-bba49d3aed8b'
}
